var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example"},[_c('h1',{staticClass:"text-h3 text-center mt-8"},[_vm._v("דף דוגמה")]),_c('v-container',[_c('event-user')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }